import { ItemGroup } from '@nesso/ui/primitives/item';

import { ClientRelationshipCard, type ContactClientLink } from '@/entities/client';

type Props = {
    clients: ContactClientLink[];
};

export function ContactDetailsSheetRelationships({ clients }: Props) {
    return (
        <section className="flex flex-col gap-1 border-t px-4 py-6">
            <h2 className="text-lg font-semibold">Relationships</h2>
            <ItemGroup className="gap-3 pt-3">
                {clients.map((link) => (
                    <div key={link.clientId} role="listitem">
                        <ClientRelationshipCard link={link} />
                    </div>
                ))}
            </ItemGroup>
        </section>
    );
}
